import Application from "./application"

let Preloader = function (params) {
	// console.log('Preloader initalizing ' + Application.tweenLength);

	/**
	 * PRELOAD STUFF
	 */
	let preloadTotal = 0
	let preloadCount = 0
	let extension = ".png"
	let images = []
	let self = this
	let preloaderElement = document.getElementById("preloader")
	let loaderFill = preloaderElement.querySelector(".preloader-fill")
	let loaderBar = preloaderElement.querySelector(".preloader-bar")
	let loadingText = preloaderElement.querySelector(".preloader-label")
	let overlay = preloaderElement.querySelector(".preloader-overlay")
	let timeline
	// Wait for modernizr to determine webp support before we start the loading sequence
	Modernizr.on("webp", function (result) {
		// console.log('webp support = ' + result);
		if (result) {
			extension = ".webp"
		}
		// temp beta hack
		// extension = ".png";
		console.log("extension is " + extension)
		self.images = [
			"common/arrow-right" + extension,
			"common/arrow-left" + extension,
			"common/slider.png",
			"common/slider-bar.png",
			"main/bg.jpg",
			"main/clubhead-1" + extension,
			"main/clubhead-2" + extension,
			"main/clubhead-3" + extension,
			"main/paths/path-high1" + extension,
			"main/paths/path-high2" + extension,
			"main/paths/path-high3" + extension,
			"main/paths/path-high4" + extension,
			"main/paths/path-high5" + extension,
			"main/paths/path-high6" + extension,
			"main/paths/path-high7" + extension,
			"main/paths/path-high8" + extension,
			"main/paths/path-high9" + extension,
			"main/paths/path-high10" + extension,
			"main/paths/path-high11" + extension,
			"main/paths/path-med1" + extension,
			"main/paths/path-med2" + extension,
			"main/paths/path-med3" + extension,
			"main/paths/path-med4" + extension,
			"main/paths/path-med5" + extension,
			"main/paths/path-med6" + extension,
			"main/paths/path-med7" + extension,
			"main/paths/path-med8" + extension,
			"main/paths/path-med9" + extension,
			"main/paths/path-med10" + extension,
			"main/paths/path-med11" + extension,
			"main/paths/path-low1" + extension,
			"main/paths/path-low2" + extension,
			"main/paths/path-low3" + extension,
			"main/paths/path-low4" + extension,
			"main/paths/path-low5" + extension,
			"main/paths/path-low6" + extension,
			"main/paths/path-low7" + extension,
			"main/paths/path-low8" + extension,
			"main/paths/path-low9" + extension,
			"main/paths/path-low10" + extension,
			"main/paths/path-low11" + extension,
			"results/bg.jpg",
			"results/logo-tsr1" + extension,
			"results/logo-tsr2" + extension,
			"results/logo-tsr3" + extension,
			"results/logo-tsr4" + extension,
			"results/tsr1" + extension,
			"results/tsr2" + extension,
			"results/tsr3" + extension,
			"results/tsr4" + extension
		]
		startLoading()
	})

	function startLoading() {
		console.log("startLoading ", self.images)
		let imageFile
		let imageTag
		for (let i = 0; i < self.images.length; i++) {
			imageFile = self.images[i]
			imageTag = new Image()
			imageTag.src = "../assets/images/" + imageFile
			imageTag.addEventListener("load", fileLoaded)
			imageTag.addEventListener("error", fileError)
		}
	}

	let percent = 0
	let loaderTween
	function fileLoaded() {
		console.log("image loaded")
		preloadCount++
		//update loader bar
		percent = Math.round((preloadCount / preloadTotal) * 100)
		if (percent > 100) {
			percent = 100
		}
		if (loaderTween !== undefined) {
			loaderTween.kill()
		}
		loaderTween = TweenLite.to(loaderFill, 1, { width: percent.toString() + "%", onComplete: checkPreloadCount })
	}

	function fileError() {
		console.log("")
		console.log("ERROR loading file, proceeding with app experience anyway...")
		console.log("")
		// comment the rest of this function out to stop the app when an image doesn't load,
		// but the app should still be usable without most image files, so we will let it proceed...
		preloadCount++
		//update loader bar
		percent = Math.round((preloadCount / preloadTotal) * 100)
		if (percent > 100) {
			percent = 100
		}
		if (loaderTween !== undefined) {
			loaderTween.kill()
		}
		loaderTween = TweenLite.to(loaderFill, 1, { width: percent.toString() + "%", onComplete: checkPreloadCount })
	}

	function checkPreloadCount() {
		//check for all images
		if (preloadCount >= preloadTotal) {
			// console.log('everything is loaded');
			// showIntro();
			closePreloader()
		}
	}

	function closePreloader() {
		timeline = new TimelineLite({ onComplete: closeComplete })
		timeline.to([loaderBar, loadingText], Application.tweenLength, { opacity: 0 })
		timeline.to(overlay, Application.tweenLength, { opacity: 0 }, "-=" + Application.tweenStagger.toString())
		// loaderTween = TweenLite.to([loaderBar, loadingText], Application.tweenLength, {opacity: 0});
		// loaderTween2 = TweenLite.to(overlay, Application.tweenLength, {opacity: 0, delay: Application.tweenStagger, onComplete: closeComplete});
	}

	function closeComplete() {
		loaderTween.kill()
		loaderTween = null
		timeline.kill()
		timeline = null
		preloaderElement.style.display = "none"
		// window.intro.open();
		window.driverSelector.preloaderClosed()
	}
}

export default Preloader
